
export default { name: "back-black" };
